<template>
    <div class="component-logos-carousel">IMPLEMENT</div>
</template>

<script setup lang="ts">
import type { ComponentLogosCarouselFragment } from '@/graphql/api'

defineProps<{
    data: ComponentLogosCarouselFragment
}>()
</script>

<style lang="scss" scoped>
.component-logos-carousel {
    width: 100%;

    .list {
        width: 100%;
        max-width: 1140px;
        list-style: none;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        padding: 40px 20px 30px;

        .list-item {
            width: 33.33%;
            padding: 0;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 20px 0;

            @include min-width(640) {
                width: 33.33%;
            }

            @include min-width(1024) {
                width: 15%;
            }

            .image {
                width: auto;
                height: 30px;

                @include min-width(410) {
                    height: 40px;
                }

                @include min-width(1024) {
                    height: 50px;
                }
            }
        }
    }
}
</style>
